import React, { useEffect, useState,  useContext } from 'react';  
import {useNavigate, useParams} from "react-router-dom";
import Axios from "axios"
import { useImmerReducer } from 'use-immer';
import { useTranslation } from 'react-i18next';
import {Grid, Typography, IconButton, Button,  CircularProgress,  Breadcrumbs, Link, Dialog, Snackbar, DialogTitle, DialogContent, DialogContentText, DialogActions, Box, Paper} from "@mui/material";
import ListingUpdate from './ListingUpdate';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet';
import "leaflet/dist/leaflet.css";
import StateContext from "../../Contexts/StateContext";

//Assets
import defaultProfilePicture from "../../Assets/defaultProfilePicture.jpg";
import PhoneIcon from '@mui/icons-material/Phone';
import cafe from '../../Assets/MapIcons/coffee.png';

// Utils
import { formatPhoneNumber } from "../../Utils/PhoneUtils";
import atm from '../../Assets/MapIcons/atm_euro.png';
import restaurant from '../../Assets/MapIcons/restaurant.png';

import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import RoomIcon from '@mui/icons-material/Room';
import CheckBoxIcon from '@mui/icons-material/CheckBox';



function ListingDetail(props) {
    const { t, i18n } = useTranslation();
    const {config, environment } = require('../../index');
    const navigate = useNavigate()
    const GlobalState = useContext(StateContext);
    const params = useParams();
    
        

    const customIcon = new L.Icon({
        iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',  
        iconSize: [25, 41],  
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
     });
    const cafeIcon = new L.Icon(
        {
            iconUrl: cafe,
            iconSize: [40, 40],
        });
    const atmIcon = new L.Icon(
        {
            iconUrl: atm,
            iconSize: [40, 40],
        });
    const restaurantIcon = new L.Icon(
        {
            iconUrl: restaurant,
            iconSize: [40, 40],
        });

    const initialState = {   
        dataIsLoading: true,  
        listingInfo: "" ,
        sellerProfileInfo: "",
        openSnack: false,
        disabledLoginBtn: false,  
    };

    function ReducerFunction(draft, action){
        switch(action.type){
            case 'catchListingInfo':
                draft.listingInfo = action.listingObject;
                 break;
            case 'loadingDone': 
                draft.dataIsLoading = false;
                break; 
            case 'catchSellerProfileInfo':  
                draft.sellerProfileInfo = action.profileObject;
                break;                 
            case 'openTheSnack':
                draft.openSnack = true;
                break;
            case 'disabledDeleteBtn':
                draft.disabledDeleteBtn = true;
                break;
            case 'allowTheDeleteBtn':
                draft.disabledDeleteBtn = false;
                break;
    }
    }

    const [state, dispatch] = useImmerReducer(ReducerFunction, initialState)  
    const [open, setOpen] = React.useState(false);

    const ProfileInfoEndpoint = config[environment].getProfileEndpoint(state.listingInfo.seller);
    const deleteEndpoint = props.type === 'car' ? config[environment].deleteCarEndpoint(params.id) : config[environment].deletePropertyEndpoint(params.id);

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteBtnDisabled, setDeleteBtnDisabled] = useState(false);

    async function handleDeleteListing() {
        setDeleteBtnDisabled(true);
        try {
            const token = GlobalState.jwtAccessToken || localStorage.getItem('jwtAccessToken');
            await Axios.delete(deleteEndpoint, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            navigate(`/${i18n.language}/${props.type === 'car' ? 'autoterkep' : 'ingatlanterkep'}`);
        } catch (e) {
            console.error("Error deleting listing:", e);
            setDeleteBtnDisabled(false);
            setOpenDeleteDialog(false);
        }
    }

    useEffect(() => {
        async function getListingInfo() {
            if (params.id.startsWith('demo-')) {
                // ... (demo data logic remains)
            }
            try {
                const endpoint = props.type === 'car' ? config[environment].getCarInfoEndpoint(params.id) : config[environment].getPropertyInfoEndpoint(params.id);  
                const response = await Axios.get(endpoint);
                
                dispatch({type: 'catchListingInfo', listingObject: response.data});               
            } catch (e) {
            }

        }
        getListingInfo();
    }, [config, environment, params.id]);

    //request to get profile info
    useEffect(() => {
        if(state.listingInfo && !params.id.startsWith('demo-')){
            async function getProfileInfo() {
                try {
                    const response = await Axios.get(ProfileInfoEndpoint);
                    
                    dispatch({type: 'catchSellerProfileInfo', profileObject: response.data});
                    dispatch({type: 'loadingDone'});
                } catch (e) {
                }
    
            }
            getProfileInfo();
        }
    }, [config, environment, state.listingInfo]); //watching for changes in state.listingInfo

    useEffect(()=>{
        if (state.openSnack){
          setTimeout(()=>{
            navigate('/terkep');
          }, 1500)
        }
      }, [state.openSnack]) //will watch for changes in state.openSnack

    const listingPictures =[state.listingInfo.picture1, state.listingInfo.picture2, state.listingInfo.picture3, state.listingInfo.picture4, state.listingInfo.picture5,
        state.listingInfo.picture6, state.listingInfo.picture7, state.listingInfo.picture8, state.listingInfo.picture9, state.listingInfo.picture10]
        .filter(picture => picture !== null);
    
    const listingPOIs = state.listingInfo.listing_pois_within_10km || [];

    const [currentPicture, setCurrentPicture] = useState(0); //0 initial state

    function NextPicture(){
        if(currentPicture === listingPictures.length - 1){
            return setCurrentPicture(0);
        }else{
            return setCurrentPicture(currentPicture + 1);
        }
    }

    function PreviousPicture(){
        if(currentPicture === 0){
            return setCurrentPicture(listingPictures.length - 1);
        }else{
            return setCurrentPicture(currentPicture - 1);
        }
    }

    const date = new Date(state.listingInfo.date_posted)
    const formattedDate = `${date.getFullYear()} - ${date.getMonth() + 1} - ${date.getDate()}`

    
    //loading spinner
    if(state.dataIsLoading === true){
        return (<Grid container justifyContent="center" alignItems="center" style={{height:"100vh"}}>
          <CircularProgress/>
        </Grid>);
    }   

    //handlers
    async function DeleteHandler(){
        const confirmDelete = window.confirm(t('Map.ConfirmDelete', "Biztosan törölni akarod az objektumot?"));
        if(confirmDelete){
            try {                
                const response = await Axios.delete(deleteEndpoint);
                dispatch({type: 'openTheSnack'});
                dispatch({type: 'disabledDeleteBtn'})
            } catch (e) {
                dispatch({
                    type: 'allowTheDeleteBtn',
                   })
            }
        }
    }    

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

  return (
    <div style={{marginLeft: '2rem', marginRight: '2rem', marginBottom: '2rem', marginTop: '50px'}} >
            <Grid item>
                <Breadcrumbs aria-label="breadcrumb" sx={{ mt: '10px' }}>
                    <Link
                        underline="hover"
                        color="inherit"
                        onClick={() => navigate(`/${i18n.language}/`)}
                        style={{ cursor: 'pointer' }}
                    >
                        {t('Header.Kezdolap')}
                    </Link>
                    <Link
                        underline="hover"
                        color="inherit"
                        onClick={() => navigate(`/${i18n.language}/terkep`)}
                        style={{ cursor: 'pointer' }}
                    >
                        {t('Header.Piacter')}
                    </Link>
                    <Link
                        underline="hover"
                        color="inherit"
                        onClick={() => navigate(`/${i18n.language}/${props.type === 'car' ? 'autoterkep' : 'ingatlanterkep'}`)}
                        style={{ cursor: 'pointer' }}
                    >
                        {props.type === 'car' ? t('SubMenu.Auto') : t('SubMenu.Ingatlan')}
                    </Link>
                    <Typography color="text.primary">
                        {state.listingInfo.title}
                    </Typography>
                </Breadcrumbs>
            </Grid>

            {GlobalState.userIsLogged && (GlobalState.userId == state.listingInfo.seller || GlobalState.userUsername === 'supergiant') && (
                <Grid item sx={{ mt: 2, display: 'flex', gap: 1 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => navigate(`/${i18n.language}/listing-update/${props.type}/${params.id}`)}
                    >
                        {t('Common.Edit')}
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => setOpenDeleteDialog(true)}
                    >
                        {t('Common.Delete')}
                    </Button>
                </Grid>
            )}

      {/* Image slider*/ }
      {listingPictures.length > 0 ? (<Grid item container justifyContent='center' 
        sx={{position: 'relative', marginTop: '1rem', marginBottom: '1rem'}}
        >
        {listingPictures.map((picture, index) => {
            return <div key={index}>
                {index === currentPicture ? (<img src={picture} alt={`Listing picture ${index}`} style={{ maxWidth: '100%', maxHeight: '500px', objectFit: 'contain' }} />) : ('')}
            </div>
        })}
        <ArrowCircleLeftIcon onClick={PreviousPicture} sx={{
            cursor: 'pointer', 
            position: 'absolute', 
            fontSize: '3rem', 
            top:'50%', 
            left:'2%',
            transform: 'translateY(-50%)',
            color: 'rgba(255, 255, 255, 0.7)',
            backgroundColor: 'rgba(16, 91, 121, 0.5)',
            borderRadius: '50%',
            '&:hover': {
                color: 'rgba(255, 255, 255, 1)',
                backgroundColor: 'rgba(16, 91, 121, 0.8)',
            },
            zIndex: 10
         }}/>
        <ArrowCircleRightIcon onClick={NextPicture} sx={{
            cursor: 'pointer', 
            position: 'absolute', 
            fontSize: '3rem', 
            top:'50%', 
            right:'2%',
            transform: 'translateY(-50%)',
            color: 'rgba(255, 255, 255, 0.7)',
            backgroundColor: 'rgba(16, 91, 121, 0.5)',
            borderRadius: '50%',
            '&:hover': {
                color: 'rgba(255, 255, 255, 1)',
                backgroundColor: 'rgba(16, 91, 121, 0.8)',
            },
            zIndex: 10
         }}/>
      </Grid>)
      :('')}

        {/* More info*/ }
        <Grid item container style={{ padding: '2rem', border: '1px solid #ddd', borderRadius: '8px', marginTop: '1rem', backgroundColor: '#f9f9f9' }} >
            <Grid item container direction="column" xs={12} md={8} spacing={1}>
                <Grid item>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#105b79' }}> {state.listingInfo.title} </Typography>
                </Grid>
                <Grid item sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                    <RoomIcon sx={{ mr: 1, color: 'text.secondary' }} />
                    <Typography variant="h6" color="text.secondary"> {state.listingInfo.borough || state.listingInfo.address} </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="subtitle2" color="text.secondary"> {t('Common.PostedOn', 'Közzétéve')}: {formattedDate} </Typography>
                </Grid>
            </Grid>
            <Grid item container xs={12} md={4} justifyContent={{ xs: 'flex-start', md: 'flex-end' }} alignItems="center">
                <Typography variant="h4" sx={{ fontWeight: 'bolder', color: 'green' }}>
                    {state.listingInfo.price
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {state.listingInfo.currency || (state.listingInfo.key === 'Auto' ? 'EUR' : 'RON')}
                    {state.listingInfo.property_status !== 'Eladó' && state.listingInfo.key !== 'Auto' && ` / ${state.listingInfo.rental_frequency}`}
                </Typography>
            </Grid>
        </Grid>

        {state.listingInfo.key === 'Auto' ? (
            <Grid item container style={{ padding: '2rem', border: '1px solid #ddd', borderRadius: '8px', marginTop: '1rem', backgroundColor: '#fff' }}>
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom sx={{ borderBottom: '2px solid #105b79', pb: 1, mb: 2 }}>{t('SubMenu.AutoDetails', 'Autó adatai')}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="body1" sx={{ mb: 1 }}><strong>{t('SubMenu.CarBrand')}:</strong> {state.listingInfo.brand}</Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}><strong>{t('SubMenu.CarModel')}:</strong> {state.listingInfo.model}</Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}><strong>{t('SubMenu.CarYear')}:</strong> {state.listingInfo.year}</Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}><strong>{t('SubMenu.CarEngineSizeL', 'Motor (l)')}:</strong> {state.listingInfo.engine_size_l} l</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="body1" sx={{ mb: 1 }}><strong>{t('SubMenu.CarFuel')}:</strong> {t(`SubMenu.Fuel${state.listingInfo.fuel}`)}</Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}><strong>{t('SubMenu.CarTransmission')}:</strong> {t(`SubMenu.Trans${state.listingInfo.transmission}`)}</Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}><strong>{t('SubMenu.CarPower')}:</strong> {state.listingInfo.power} hp</Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}><strong>{t('SubMenu.CarMileage')}:</strong> {state.listingInfo.mileage && state.listingInfo.mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} km</Typography>
                </Grid>
                {state.listingInfo.features && (
                    <Grid item xs={12} sx={{ mt: 2, pt: 2, borderTop: '1px solid #eee' }}>
                        <Typography variant="body1"><strong>{t('SubMenu.CarFeatures')}:</strong> {state.listingInfo.features}</Typography>
                    </Grid>
                )}
            </Grid>
        ) : (
        <Grid item container justifyContent="flex-start" style={{padding: '1rem', border:'1px solid #105b79', marginTop:'1rem'}}>
            {state.listingInfo.rooms ? (
            <Grid item xs={2} style={{display: 'flex'}}>                
                <Typography variant='h6'>{state.listingInfo.rooms} {t('Academy.Rooms', 'Szobák')} </Typography>
            </Grid>
            ): (
            ""
            )}

            {state.listingInfo.airconditioning ? (
            <Grid item xs={2} style={{display: 'flex'}}>
                <CheckBoxIcon style={{color: 'blue', fontSize:'2rem'}}/>
                <Typography variant='h6'>{t('Amenities.AirConditioning', 'Légkondicionálás')}</Typography>
            </Grid>
            ): (
            ""
            )}

            {state.listingInfo.parking ? (
            <Grid item xs={2} style={{display: 'flex'}}>
                <CheckBoxIcon style={{color: 'blue', fontSize:'2rem'}}/>
                <Typography variant='h6'>{t('Amenities.Parking', 'Parkoló')}</Typography>
            </Grid>
            ): (
            ""
            )}

            {state.listingInfo.pool ? (
            <Grid item xs={2} style={{display: 'flex'}}>
                <CheckBoxIcon style={{color: 'blue', fontSize:'2rem'}}/>
                <Typography variant='h6'>{t('Amenities.Pool', 'Medence')}</Typography>
            </Grid>
            ): (
            ""
            )}

            {state.listingInfo.wellness ? (
            <Grid item xs={2} style={{display: 'flex'}}>
                <CheckBoxIcon style={{color: 'blue', fontSize:'2rem'}}/>
                <Typography variant='h6'>{t('Amenities.Wellness', 'Wellness')}</Typography>
            </Grid>
            ): (
            ""
            )}

            {state.listingInfo.elevator ? (
            <Grid item xs={2} style={{display: 'flex'}}>
                <CheckBoxIcon style={{color: 'blue', fontSize:'2rem'}}/>
                <Typography variant='h6'>{t('Amenities.Elevator', 'Felvonór')}</Typography>
            </Grid>
            ): (
            ""
            )}

            {state.listingInfo.petsallowed ? (
            <Grid item xs={2} style={{display: 'flex'}}>
                <CheckBoxIcon style={{color: 'blue', fontSize:'2rem'}}/>
                <Typography variant='h6'>{t('Amenities.PetsAllowed', 'Háziállatok engedélyezettek')}</Typography>
            </Grid>
            ): (
            ""
            )}
        </Grid>
        )}
        
        {/* Description */}
        {state.listingInfo.description && (
            <Grid item container sx={{ mt: 2 }}>
                <Grid item xs={12}>
                    <Box sx={{ p: 3, border: '1px solid #ddd', borderRadius: '8px', backgroundColor: '#fff' }}>
                        <Typography variant="h5" sx={{ color: '#105b79', mb: 2, fontWeight: 'bold' }}> {t('Academy.Description', 'Leírás')} </Typography>
                        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}> {state.listingInfo.description} </Typography>
                    </Box>
                </Grid>
            </Grid>
        )}

        {/* Seller info & Map */ }
        <Grid item container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12} md={4}>
                <Box sx={{ p: 3, border: '1px solid #ddd', borderRadius: '8px', backgroundColor: '#f9f9f9', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography variant="h6" sx={{ color: '#105b79', mb: 2, fontWeight: 'bold' }}>{t('Common.SellerInfo', 'Eladó adatai')}</Typography>
                    <Box 
                        component="img"
                        src={state.sellerProfileInfo.profile_picture !== null ? state.sellerProfileInfo.profile_picture : defaultProfilePicture } 
                        alt="Profile picture" 
                        sx={{ width: "120px", height: "120px", borderRadius: '50%', objectFit: 'cover', cursor: 'pointer', mb: 2, border: '2px solid #105b79', mx: 'auto' }}
                        onClick={()=> navigate(`/institutions/${state.sellerProfileInfo.seller}`)}
                    />
                    <Typography variant="h6" sx={{ color: 'green', fontWeight: 'bold', mb: 1 }}> 
                        {state.sellerProfileInfo.company_name}
                    </Typography>
                    <Link 
                        component="button"
                        variant="caption"
                        onClick={() => navigate(`/${i18n.language}/institutions/${state.sellerProfileInfo.seller}`)}
                        sx={{ color: 'text.secondary', textDecoration: 'underline', mb: 2, display: 'block', mx: 'auto' }}
                    >
                        {t('Common.ViewProfile', 'Profil megtekintése')}
                    </Link>
                    <Button 
                        variant="contained" 
                        size="small"
                        startIcon={<PhoneIcon />}
                        fullWidth
                        href={`tel:${state.sellerProfileInfo.phone_number}`}
                        sx={{ mt: 1, bgcolor: '#105b79', '&:hover': { bgcolor: '#0d4a63' } }}
                    >
                        {formatPhoneNumber(state.sellerProfileInfo.phone_number)}
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={12} md={8}>
                <Grid container spacing={1} style={{ height: '100%' }}>
                    {listingPOIs.length > 0 && (
                        <Grid item xs={4} style={{ overflow: "auto", height: "35rem" }}>
                            {listingPOIs.map(poi => {
                                function DegreeToRadian(coordinate){
                                    return coordinate * Math.PI/180;
                                }

                                function CalculateDistance() {
                                    const latitude1 = DegreeToRadian(state.listingInfo.latitude);
                                    const longitude1 = DegreeToRadian(state.listingInfo.longitude);
                                    const latitude2 = DegreeToRadian(poi.location.coordinates[1]);
                                    const longitude2 = DegreeToRadian(poi.location.coordinates[0]);  

                                    const latDiff = latitude2 - latitude1;
                                    const lonDiff = longitude2 - longitude1;
                                    const R = 6371 / 1;

                                    const a =
                                        Math.sin(latDiff / 2) * Math.sin(latDiff / 2) +
                                        Math.cos(latitude1) *
                                            Math.cos(latitude2) *
                                            Math.sin(lonDiff / 2) *
                                            Math.sin(lonDiff / 2);
                                    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

                                    const dist = R * c;
                                    return dist.toFixed(2);
                                }
                                
                                return (
                                    <div key={poi.id} style={{marginBottom: '0.5rem', border:'1px solid grey', padding: '0.5rem'}}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}> {poi.name} </Typography>
                                        <Typography variant="caption"> {poi.type} | {' '}
                                        <span style={{ fontWeight:"bolder", color: "green"}}> {CalculateDistance()} </span> km </Typography>
                                    </div>
                                )
                            })}   
                        </Grid>
                    )}
                    <Grid item xs={listingPOIs.length > 0 ? 8 : 12} style={{ height: '35rem' }}>                
                        <MapContainer center={[state.listingInfo.latitude, state.listingInfo.longitude]} zoom={14} scrollWheelZoom={true} style={{ height: '100%', width: '100%', borderRadius: '8px' }}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url={config[environment].osmTiles}
                            />
                            <Marker position={[state.listingInfo.latitude, state.listingInfo.longitude]} icon={customIcon}>
                                <Popup>
                                    {state.listingInfo.title}
                                </Popup>
                            </Marker>  
                            {listingPOIs.map(poi => {
                                function PoiIcon(){
                                    if(poi.type === 'Kávézó'){
                                        return cafeIcon
                                    }else if(poi.type === 'Atm'){
                                        return atmIcon
                                    }else if(poi.type === 'Étterem'){
                                        return restaurantIcon
                                    }
                                }
                                return (
                                    <Marker 
                                        key={poi.id} 
                                        position={[poi.location.coordinates[1],poi.location.coordinates[0]]}
                                        icon={PoiIcon()} >
                                        <Popup>
                                            {poi.name}
                                        </Popup>
                                    </Marker>
                                )
                            })}                                       
                        </MapContainer>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        <Snackbar
          open={state.openSnack}     
          message={t('Map.ObjectDeletedSuccess', 'Sikeresen törölted a térképobjektumot!')}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}         
        />

        <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t('Common.ConfirmDelete', 'Törlés megerősítése')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('Common.DeleteConfirmationText', 'Biztosan törölni szeretné ezt a hirdetést? Ez a művelet nem vonható vissza.')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
                    {t('Common.Cancel', 'Mégse')}
                </Button>
                <Button onClick={handleDeleteListing} color="error" autoFocus disabled={deleteBtnDisabled}>
                    {deleteBtnDisabled ? <CircularProgress size={24} /> : t('Common.Delete', 'Törlés')}
                </Button>
            </DialogActions>
        </Dialog>
    </div>
  );
}

export default ListingDetail
